import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from "@mui/styles";
import Skeleton from '@mui/material/Skeleton';
import themeMaker, {bssMakeStyles}  from '../../lib/theming';

/**
 * 
 * @param {{    
 *  SkeletonProps: import('@mui/lab').SkeletonProps
 * }} param0 
 * @returns 
 */
const DefaultLoadingComponent = ({
    SkeletonProps = {}
}) => {

    const classes = bssMakeStyles();    

    return (       
        <Skeleton 
            animation="wave" 
            variant="rect" 
            height={40} 
            className={classes.rounded5}
            {...SkeletonProps}
        />
    )
}

const FullScreenDefaultLoadingComponent = ({
    BackdropProps = {}
}) => {
    const classes = bssMakeStyles();

    return (
        <Backdrop className={classes.backdrop} open={true} {...BackdropProps}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default DefaultLoadingComponent;
export {FullScreenDefaultLoadingComponent}